<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 2.5V1.75C6.56579 1.75 1.75 6.56579 1.75 12.5H2.5H3.25C3.25 7.39421 7.39421 3.25 12.5 3.25V2.5ZM22.5 12.5H23.25C23.25 6.56579 18.4342 1.75 12.5 1.75V2.5V3.25C17.6058 3.25 21.75 7.39421 21.75 12.5H22.5ZM12.5 22.5V23.25C18.4342 23.25 23.25 18.4342 23.25 12.5H22.5H21.75C21.75 17.6058 17.6058 21.75 12.5 21.75V22.5ZM2.5 12.5H1.75C1.75 18.4342 6.56579 23.25 12.5 23.25V22.5V21.75C7.39421 21.75 3.25 17.6058 3.25 12.5H2.5ZM8.5 18V17.25C7.53421 17.25 6.75 16.4658 6.75 15.5H6H5.25C5.25 17.2942 6.70579 18.75 8.5 18.75V18ZM11 15.5H10.25C10.25 16.4658 9.46579 17.25 8.5 17.25V18V18.75C10.2942 18.75 11.75 17.2942 11.75 15.5H11ZM8.5 13V13.75C9.46579 13.75 10.25 14.5342 10.25 15.5H11H11.75C11.75 13.7058 10.2942 12.25 8.5 12.25V13ZM6 15.5H6.75C6.75 14.5342 7.53421 13.75 8.5 13.75V13V12.25C6.70579 12.25 5.25 13.7058 5.25 15.5H6ZM12.5 6V5.25C10.7058 5.25 9.25 6.70579 9.25 8.5H10H10.75C10.75 7.53421 11.5342 6.75 12.5 6.75V6ZM15 8.5H15.75C15.75 6.70579 14.2942 5.25 12.5 5.25V6V6.75C13.4658 6.75 14.25 7.53421 14.25 8.5H15ZM12.5 11V11.75C14.2942 11.75 15.75 10.2942 15.75 8.5H15H14.25C14.25 9.46579 13.4658 10.25 12.5 10.25V11ZM10 8.5H9.25C9.25 10.2942 10.7058 11.75 12.5 11.75V11V10.25C11.5342 10.25 10.75 9.46579 10.75 8.5H10ZM16.5 18V17.25C15.5342 17.25 14.75 16.4658 14.75 15.5H14H13.25C13.25 17.2942 14.7058 18.75 16.5 18.75V18ZM19 15.5H18.25C18.25 16.4658 17.4658 17.25 16.5 17.25V18V18.75C18.2942 18.75 19.75 17.2942 19.75 15.5H19ZM16.5 13V13.75C17.4658 13.75 18.25 14.5342 18.25 15.5H19H19.75C19.75 13.7058 18.2942 12.25 16.5 12.25V13ZM14 15.5H14.75C14.75 14.5342 15.5342 13.75 16.5 13.75V13V12.25C14.7058 12.25 13.25 13.7058 13.25 15.5H14Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgGroup',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
